import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MedicGuideButtonProps } from '../../../interfaces/props/MedicGuideButtonProps';
import './styles.css';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { sxFeatureCard } from '../sxProps';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';

function MedicGuideButton(props: MedicGuideButtonProps) {

    const accessibility = useAccessibility();

    const navigate = useNavigate(); 

    const handleClick = () => {
        if (props.to?.startsWith('http')) window.open(props.to, '_blank')
        else navigate(props.to)
    }

    return (
        <Button sx={sxFeatureCard} onClick={handleClick} style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
            <FontAwesomeIcon icon={props.icon} style={accessibility.contrastColorAccessibility} size="xl" className='feature-card-icon' />
            <span className='medic-guide-button-name' style={accessibility.textStyleAccessibility}>{props.name}</span>
        </Button>
    );
}

export default MedicGuideButton;